import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Pulled from .env (REACT_APP_FIREBASE_*).
// You can find the values in Firebase Console → Project Settings → Your apps.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
};

// Only initialize Firebase if the config is actually present. This keeps the
// public site (`/`, `/mastermind`, `/guide`, etc.) working even if the team
// hasn't set up the .env yet — only `/admin` and `/lead/:slug` will then show
// a clear hint that Firebase isn't configured.
export const isFirebaseConfigured = Boolean(
  firebaseConfig.apiKey && firebaseConfig.projectId && firebaseConfig.appId,
);

let app = null;
let auth = null;
let db = null;
let storage = null;

if (isFirebaseConfigured) {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  db = getFirestore(app);
  storage = getStorage(app);
} else if (typeof console !== 'undefined') {
  // eslint-disable-next-line no-console
  console.warn(
    '[Firebase] No config detected. Set REACT_APP_FIREBASE_* in .env to enable ' +
      'Auth / Firestore / Storage. Public pages keep working; /admin and ' +
      '/lead/:slug will show a configuration hint.',
  );
}

export { app, auth, db, storage };
export default app;
